<template>
  <v-dialog v-model="dialog" persistent max-width="550">
    <v-card>
      <v-card-title>
        <v-icon left color="green">mdi-check-decagram</v-icon>
        Acknowledge Task
      </v-card-title>
      <v-card-text v-if="taskLog">
        <div class="mb-3">
          <div class="subtitle-1 font-weight-bold">
            {{ taskLog.task ? taskLog.task.title : "" }}
          </div>
          <div class="body-2 grey--text">
            Assigned to:
            {{
              taskLog.task && taskLog.task.assigned_to_user
                ? taskLog.task.assigned_to_user.full_name
                : ""
            }}
          </div>
          <div class="body-2 grey--text">
            Completed:
            {{ taskLog.completed_at ? formatDate(taskLog.completed_at) : "-" }}
          </div>
        </div>

        <!-- User's completion note -->
        <v-alert v-if="taskLog.completion_note" type="info" outlined dense>
          <div class="caption">User's Note:</div>
          {{ taskLog.completion_note }}
        </v-alert>

        <v-textarea
          dense
          v-model="admin_comment"
          label="Admin Comment (optional)"
          placeholder="Add a comment..."
          outlined
          rows="3"
          counter="500"
          maxlength="500"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="green" dark :loading="loading" @click="submit">
          <v-icon left>mdi-check</v-icon>
          Acknowledge
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    value: { type: Boolean, default: false },
    taskLog: { type: Object, default: null },
  },
  data() {
    return {
      admin_comment: "",
      loading: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.admin_comment = "";
      }
    },
  },
  methods: {
    ...mapActions({
      acknowledge_task_log: "reminder/acknowledge_task_log",
      set_notification: "notification/set_notification",
    }),
    formatDate(d) {
      if (!d) return "";
      return new Date(d).toLocaleString();
    },
    close() {
      this.dialog = false;
    },
    submit() {
      if (!this.taskLog) return;
      this.loading = true;
      this.acknowledge_task_log({
        logId: this.taskLog.id,
        admin_comment: this.admin_comment,
      })
        .then(() => {
          this.loading = false;
          this.set_notification({
            message: "Task acknowledged successfully!",
            type: "success",
          });
          this.$emit("acknowledged");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.$alert({
            title: "Error",
            message: err.response ? err.response.data.error : err.message,
            color: "error",
            icon: "mdi-alert-circle",
          });
        });
    },
  },
};
</script>
